import React, { useEffect } from 'react';

import { useScript } from '@woovi/hooks';

type MetaPixelScriptProps = {
  token: string;
};

declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}

type Fbq = {
  (command: string, ...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  loaded: boolean;
  version: string;
  push: Fbq;
};

const MetaPixelScript = (props: MetaPixelScriptProps): React.ReactNode => {
  const initFacebookPixel = (token: string): void => {
    if (window.fbq) {
      return;
    }

    const fbq: Fbq = (window.fbq = function (...args: unknown[]): void {
      if (fbq.callMethod) {
        fbq.callMethod(...args);
      } else {
        fbq.queue.push(args);
      }
    } as Fbq);

    if (!window._fbq) {
      window._fbq = fbq;
    }

    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];

    fbq('init', token);
    fbq('track', 'PageView');
    fbq('track', 'InitiateCheckout');
  };

  useEffect(() => {
    initFacebookPixel(props.token);
  }, [props.token]);

  useScript({
    src: `https://connect.facebook.net/en_US/fbevents.js`,
    checkForExisting: true,
    'data-testid': 'facebook-jssdk',
  });

  return <div />;
};

export default MetaPixelScript;
